import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface QuickTag {
  label: string;
  insertText: string;
}

export function usePatientQuickTags(patientId?: string, limit = 8) {
  const [tags, setTags] = useState<QuickTag[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!patientId) {
      setTags([]);
      return;
    }

    let cancelled = false;
    setLoading(true);

    (async () => {
      const { data, error } = await supabase
        .from("lab_results_onboarding")
        .select("test_name, created_at, lab_subcategories(name, lab_categories(name))")
        .eq("patient_id", patientId)
        .order("created_at", { ascending: false })
        .limit(100);

      if (cancelled) return;

      if (error || !data) {
        console.error("Erro ao buscar tags rápidas:", error);
        setTags([]);
        setLoading(false);
        return;
      }

      const seen = new Set<string>();
      const result: QuickTag[] = [];

      for (const row of data as any[]) {
        const name = row.test_name?.trim();
        if (!name) continue;
        const key = name.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);

        const category = row.lab_subcategories?.lab_categories?.name?.trim();
        const insertText = category
          ? `${category} - ${name}: `
          : `${name}: `;

        result.push({ label: name, insertText });
        if (result.length >= limit) break;
      }

      setTags(result);
      setLoading(false);
    })();

    return () => {
      cancelled = true;
    };
  }, [patientId, limit]);

  return { tags, loading };
}
